import api from './client.js'

export const meAPI = {
  timeline:     () => api.get('/me/timeline'),
  homeWidgets:  () => api.get('/me/home-widgets'),
}
